import { RotateCcw, Trash2 } from "lucide-react";
import { clsx } from "clsx";
import { useState } from "react";
import { Task } from "../lib/tauri";
import { formatDueDate } from "../lib/date";
import { useTaskStore } from "../stores/taskStore";
import { useUiStore } from "../stores/uiStore";
import { haptic } from "../lib/haptics";

export function TrashedTaskItem({ task }: { task: Task }) {
  const restoreTask = useTaskStore((s) => s.restoreTask);
  const permanentlyDelete = useTaskStore((s) => s.permanentlyDelete);
  const showToast = useUiStore((s) => s.showToast);
  const [confirming, setConfirming] = useState(false);

  const handleRestore = async () => {
    haptic("success");
    await restoreTask(task);
    showToast("復元しました");
  };

  const handlePermanentDelete = async () => {
    haptic("error");
    await permanentlyDelete(task.id);
    showToast("完全に削除しました");
    setConfirming(false);
  };

  return (
    <div className="group flex min-h-[52px] items-center gap-3 rounded-md border border-border bg-card px-4 py-3 opacity-70 transition-colors hover:opacity-100 dark:border-border-dark dark:bg-card-dark">
      <div className="self-stretch w-[3px] rounded-full bg-muted" />
      <div className="min-w-0 flex-1">
        <h3 className={clsx("truncate text-sm font-medium text-muted line-through dark:text-muted-dark")}>{task.title}</h3>
        <div className="mt-0.5 flex items-center gap-3 text-xs text-dim">
          {task.dueDate && <span className="font-mono">{formatDueDate(task.dueDate)}</span>}
          {task.description && <span className="truncate">{task.description}</span>}
        </div>
      </div>
      {!confirming ? (
        <div className="flex items-center gap-1">
          <button
            type="button"
            aria-label="復元"
            onClick={() => void handleRestore()}
            className="flex h-9 items-center gap-1 rounded-md border border-border bg-card px-2.5 text-xs font-medium text-success-600 hover:bg-success-500/10 dark:border-border-dark dark:bg-card-dark"
          >
            <RotateCcw className="h-3.5 w-3.5" />
            復元
          </button>
          <button
            type="button"
            aria-label="完全に削除"
            onClick={() => setConfirming(true)}
            className="flex h-9 w-9 items-center justify-center rounded-md text-danger-500 hover:bg-danger-500/10"
          >
            <Trash2 className="h-4 w-4" />
          </button>
        </div>
      ) : (
        <div className="flex items-center gap-1">
          <span className="text-xs text-muted dark:text-muted-dark">本当に？</span>
          <button
            type="button"
            onClick={() => void handlePermanentDelete()}
            className="flex h-9 items-center rounded-md bg-danger-500 px-2.5 text-xs font-semibold text-white"
          >
            削除
          </button>
          <button
            type="button"
            onClick={() => setConfirming(false)}
            className="flex h-9 items-center rounded-md border border-border px-2.5 text-xs font-medium text-muted dark:border-border-dark dark:text-muted-dark"
          >
            キャンセル
          </button>
        </div>
      )}
    </div>
  );
}
